export const EVENTS_PER_PAGE_DEFAULT = 18;
